import tileNapoliBari01 from "assets/medium/NAPOLI-BARI/01.jpg";
import tileNapoliBari02 from "assets/medium/NAPOLI-BARI/02.jpg";
import tileNapoliBari03 from "assets/medium/NAPOLI-BARI/03.jpg";
import tileNapoliBari04 from "assets/medium/NAPOLI-BARI/04.jpg";
import tileNapoliBari05 from "assets/medium/NAPOLI-BARI/05.jpg";
import tileNapoliBari06 from "assets/medium/NAPOLI-BARI/06.jpg";
import tileNapoliBari07 from "assets/medium/NAPOLI-BARI/07.jpg";
import tileNapoliBari08 from "assets/medium/NAPOLI-BARI/08.jpg";
import tileNapoliBari09 from "assets/medium/NAPOLI-BARI/09.jpg";
import tileNapoliBari10 from "assets/medium/NAPOLI-BARI/10.jpg";
import tileNapoliBari11 from "assets/medium/NAPOLI-BARI/11.jpg";
import tileNapoliBari12 from "assets/medium/NAPOLI-BARI/12.jpg";
import tileNapoliBari13 from "assets/medium/NAPOLI-BARI/13.jpg";
import tileNapoliBari14 from "assets/medium/NAPOLI-BARI/14.jpg";
import tileNapoliBari15 from "assets/medium/NAPOLI-BARI/15.jpg";
import tileNapoliBari16 from "assets/medium/NAPOLI-BARI/16.jpg";
import tileNapoliBari17 from "assets/medium/NAPOLI-BARI/17.jpg";
import tileNapoliBari18 from "assets/medium/NAPOLI-BARI/18.jpg";
import tileNapoliBari19 from "assets/medium/NAPOLI-BARI/19.jpg";
import tileNapoliBari20 from "assets/medium/NAPOLI-BARI/20.jpg";
import tileNapoliBari21 from "assets/medium/NAPOLI-BARI/21.jpg";
import tileNapoliBari22 from "assets/medium/NAPOLI-BARI/22.jpg";
import tileNapoliBari23 from "assets/medium/NAPOLI-BARI/23.jpg";
import tileNapoliBari24 from "assets/medium/NAPOLI-BARI/24.jpg";
import tileNapoliBari25 from "assets/medium/NAPOLI-BARI/25.jpg";
import fullImage from "assets/medium/NAPOLI-BARI/complete.jpg";

import { ILevel, LevelDifficulties, LevelTypes } from "models";

export const napoliBari: ILevel = {
  difficulty: LevelDifficulties.medium,
  type: LevelTypes.roadSign,
  name: "Napoli - Bari",
  fullImage,
  successDialogContent: {
    subtitle: "Hai completato la linea NAPOLI - BARI",
    link: `https://www.napolibari.it/content/fsinapolibari/it.html`,
    contents: [
      {
        text: "Riduzione dei ",
        isBold: false,
      },
      {
        text: "tempi di percorrenza",
        isBold: true,
      },
      {
        text: ", maggiore ",
        isBold: false,
      },
      {
        text: "sostenibilità ambientale",
        isBold: true,
      },
      {
        text: ", integrazione dei servizi di rete e ",
        isBold: false,
      },
      {
        text: "intermodalità",
        isBold: true,
      },
      {
        text:
          ": la nuova linea ad alta velocità e alta capacità che collegherà Napoli a Bari rappresenta un salto in avanti per l’intera ",
        isBold: false,
      },
      {
        text: "economia del Mezzogiorno",
        isBold: true,
      },
      {
        text:
          ". Consentirà infatti di integrare la Puglia nel sistema AV/AC nazionale, offrendo la possibilità di ",
        isBold: false,
      },
      {
        text: "intensificare i rapporti commerciali e turistici",
        isBold: true,
      },
      {
        text: " tra il Sud Italia, il resto del Paese e l’Europa meridionale.",
        isBold: false,
      },
    ],
  },
  tiles: [
    tileNapoliBari01,
    tileNapoliBari02,
    tileNapoliBari03,
    tileNapoliBari04,
    tileNapoliBari05,
    tileNapoliBari06,
    tileNapoliBari07,
    tileNapoliBari08,
    tileNapoliBari09,
    tileNapoliBari10,
    tileNapoliBari11,
    tileNapoliBari12,
    tileNapoliBari13,
    tileNapoliBari14,
    tileNapoliBari15,
    tileNapoliBari16,
    tileNapoliBari17,
    tileNapoliBari18,
    tileNapoliBari19,
    tileNapoliBari20,
    tileNapoliBari21,
    tileNapoliBari22,
    tileNapoliBari23,
    tileNapoliBari24,
    tileNapoliBari25,
  ],
};
